// extracted by mini-css-extract-plugin
module.exports = {"Background":"_9RUQYWroFrn304b-BZMht","Background-collapsed":"B5atfw8ufUOrElfq2FVhi","Wrapper":"cDQByK1y3Ps6dZuuQwfxj"};